import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueLocalStorage from 'vue-localstorage'
import GlobalMixin from '@/mixins/GlobalMixin'
import HomeComponent from '@/components/HomeComponent.vue'
import ShareComponent from '@/components/ShareComponent.vue'
import PlatesComponent from '@/components/PlatesComponent.vue'
import AnswerListComponent from '@/components/AnswerListComponent.vue'
import AnswerSlideComponent from '@/components/AnswerSlideComponent.vue'
import AnswerComponent from '@/components/AnswerComponent.vue'
import App from '@/App.vue'

// import style
import 'swiper/css/swiper.css'
import '@/assets/css/style.css'
import './registerServiceWorker'

Vue.config.productionTip = false

// plugins
Vue.use(VueAwesomeSwiper)
Vue.use(VueLocalStorage)
// mixins
Vue.mixin(GlobalMixin)
// components
Vue.component('HomeComponent', HomeComponent)
Vue.component('ShareComponent', ShareComponent)
Vue.component('PlatesComponent', PlatesComponent)
Vue.component('AnswerListComponent', AnswerListComponent)
Vue.component('AnswerSlideComponent', AnswerSlideComponent)
Vue.component('AnswerComponent', AnswerComponent)

new Vue({
  render: h => h(App),
}).$mount('#app')
